import React, { useState, useEffect } from "react";
import { ActualizarComercio } from "../../hacienda/actividadEconomica/modalActualizarComercio";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTableR";
import { Toasts } from "../../toasts";
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";
// IMPORTS DE MATERIAL UI
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
// IMPORTS DE CHART JS
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import CardsModule from "../../cartas";
import comercioService from "../actividadEconomica/service/comercio.service"; // Importar el servicio

// Registrar los componentes necesarios de Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const headCells = [
  {
    id: "idcomercio",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "CODIGO",
    textAlign: "center",
  },
  {
    id: "ritm",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "RITM",
    textAlign: "center",
  },
  {
    id: "rif",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "RIF",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "NOMBRE",
    textAlign: "center",
  },
  {
    id: "direccion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "DIRECCIÓN",
    textAlign: "center",
  },
  {
    id: "reprelegal",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " CEDULA",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaComercio(props) {
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [statusCome, setStatusCome] = useState();
  const [configCome, setConfigCome] = useState();
  const [actividadxCome, setActividadxCome] = useState();
  const [actividad, setActividad] = useState();
  const [inmuebleCome, setInmuebleCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [pagow, setPagow] = useState();
  const [retencion, setRetencion] = useState();
  const [multas, setMultas] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [facturasPagadas, setFacturasPagadas] = useState();
  const [facturasPagadasEtax, setFacturasPagadasEtax] = useState();``
  const [facturasOtrosPgosEtax, setFacturasOtrosPgosEtax] = useState();
  const factorCambio = JSON.parse(localStorage.getItem('factorCambio'))

  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [anioActu] = useState(localStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const permiso = JSON.parse(localStorage.getItem("acccontribuyente"));
  const [permisoDecla, setPermisoDecla] = useState();
  const [permisoExon, setPermisoExon] = useState();
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const activeCount = records.filter(r => r.status && r.status.toString() === "51").length;
  const inactiveCount = records.filter(r => r.status && r.status.toString() === "52").length;

  // Nuevos estados para los tipos de contribuyente
  const [tiposContribuyente, setTiposContribuyente] = useState([]);
  const [conteoTipos, setConteoTipos] = useState({});

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idcomercio.includes(target.value) === null
                ? ""
                : x.idcomercio.includes(target.value)) ||
              (x.ritm === null
                ? ""
                : x.ritm.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.rif === null
                ? ""
                : x.rif.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.nombre === null
                ? ""
                : x.nombre
                  .toLowerCase()
                  .includes(target.value.toLowerCase())) ||
              (x.reprelegal === null ? "" : x.reprelegal.includes(target.value))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  // Función para contar comercios por tipo de contribuyente
  const contarPorTipoContribuyente = (comercios) => {
    const conteo = {};

    comercios.forEach(comercio => {
      const tipo = comercio.tipocontribuyente && comercio.tipocontribuyente.trim() ? comercio.tipocontribuyente.trim() :  "PERMANENTE";
      conteo[tipo] = (conteo[tipo] || 0) + 1;
    });
    setConteoTipos(conteo);
    return conteo;
  };

  // Refactorizadas usando el servicio
  const seleccionarComercios = async () => {
    setActivate(true);
    setRecords([]);
    try {
      const data = await comercioService.getComercios();
      if (data.length > 0) {
        setRecords(data);
        contarPorTipoContribuyente(data);
      }
    } catch (error) {
      console.error("Error cargando comercios:", error);
    } finally {
      setActivate(false);
    }
  };

  const seleccionarTiposContribuyente = async () => {
    try {
      const data = await comercioService.getTiposContribuyente();
      setTiposContribuyente(data);
    } catch (error) {
      console.error("Error cargando tipos de contribuyente:", error);
    }
  };

  const seleccionarConfiguracion = async () => {
    try {
      const data = await comercioService.getConfiguracionIndustria();
      setConfigCome(data);
      if (data.valorutMulta === null) {
        if (data.factormulta === 2) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "El valor de la unidad tributaria para el año " + anioActu + " no esta definido",
            icono: "informacion",
          });
        } else if (data.factormulta > 2) {
          let tipo = data.factormulta - 3;
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "El valor del " + (tipo === 0 ? "Petro" : tipo === 1 ? "Sueldo Minimo" : tipo === 2 ? "UCAMP" : "") + " para el año " + anioActu + " en el mes en curso no esta definido",
            icono: "informacion",
          });
        }
      }
    } catch (error) {
      console.error("Error cargando configuración:", error);
    }
  };

  const seleccionarStatus = async () => {
    try {
      const data = await comercioService.getStatus();
      var come = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].tipostatus.trim() === "COMERCIO") {
          come.push({
            idstatus: data[i].idstatus,
            descripcion: data[i].descripcion,
          });
        }
        setStatusCome(come);
      }
    } catch (error) {
      console.error("Error cargando status:", error);
    }
  };

  // Método unificado para cargar todos los datos de un comercio
  const SelectComercio = async (idcomercio, index) => {
    setActivate(true);
    try {
      const allData = await comercioService.getAllComercioData(
        idcomercio,
        fechaSistema,
        espiritu,
        parseInt(localStorage.getItem("efiscalanio"))
      );

      // Procesar deuda y histórico
      const deu = [];
      const his = [];
      if (allData.deuda) {
        for (let i = 0; i < allData.deuda.length; i++) {
          if (allData.deuda[i].fechapago === null) {
            deu.push({
              anio: allData.deuda[i].anio,
              mes: allData.deuda[i].mes.replace("'", "").replace("'", ""),
              monto: allData.deuda[i].mondeu,
              intereses: allData.deuda[i].intmoradeu,
              recargo: allData.deuda[i].recargodeu,
              multa: allData.deuda[i].multa,
              retenciones: allData.deuda[i].retencion,
              credito: allData.deuda[i].acreditacion,
              totalperi: allData.deuda[i].subtotal,
              status: allData.deuda[i].estatus,
              idfac: allData.deuda[i].idfact,
              nummes: allData.deuda[i].nmes,
              estatusfac: allData.deuda[i].estatusfac,
              tipotransaccion: allData.deuda[i].tipotransaccion,
            });
          } else {
            his.push({
              anio: allData.deuda[i].anio,
              mes: allData.deuda[i].mes.replace("'", "").replace("'", ""),
              monto: allData.deuda[i].mondeu,
              intereses: allData.deuda[i].intmoradeu,
              recargo: allData.deuda[i].recargodeu,
              multa: allData.deuda[i].multa,
              descuento: allData.deuda[i].mondescue,
              recibo: allData.deuda[i].numreci,
              fechapago: allData.deuda[i].fechapago,
              status: allData.deuda[i].estatus,
              idfac: allData.deuda[i].idfact,
              estatusfac: allData.deuda[i].estatusfac,
              tipotransaccion: allData.deuda[i].tipotransaccion,
            });
          }
        }
      }

      setComercio(allData.comercio || []);
      setActividad(allData.actividad || []);
      setActividadxCome(allData.actividadxComercio || []);
      setInmuebleCome(allData.inmueble || []);
      setUsuariow(allData.usuarioWeb || []);
      setDeuda(deu || []);
      setHistorico(his || []);
      setPagow(allData.pagosWeb || []);
      setRetencion(allData.retenciones || []);
      setMultas(allData.multas || []);
      setFacturasPagadas(allData.facturasPagadas || []);

      // Setear persona
      if (allData.comercio) {
        setPersona({
          cedula: allData.comercio.cedula,
          nombres: allData.comercio.nombres,
          apellidos: allData.comercio.apellidos,
          correoe: allData.comercio.correoe,
          tlf1: allData.comercio.tlf1,
          tlf2: allData.comercio.tlf2,
          fnacimiento: allData.comercio.fnacimiento,
          nacionalidad: allData.comercio.nacionalidad,
          sexo: allData.comercio.sexo,
          direccion: allData.comercio.direccionp,
        });
      }

      setMostrar5(true);
    } catch (error) {
      console.error("Error cargando datos del comercio:", error);
    } finally {
      setActivate(false);
    }
  };

  const agregarComercio = (permiso) => (e) => {
    e.preventDefault();
    if (permiso === "1") {
      setOperacion(1);
      setComercio();
      setActividad();
      setActividadxCome();
      setInmuebleCome();
      setUsuariow();
      setPersona();
      setDeshabilitado(false);
      setMostrar5(true);
    } else {
      setToast({
        mostrar: true,
        titulo: "Notificación",
        mensaje: "No posee permiso para registrar un Contribuyente de actividades Economicas",
      });
    }
  };

  const cerrarModalActualizar = () => {
    setComercio();
    setActividad();
    setActividadxCome();
    setInmuebleCome();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    seleccionarComercios();
    setFacturasPagadas();
    setFacturasPagadasEtax();
    setFacturasOtrosPgosEtax();
  };

  const validarActuComercio = () => {
    if (operacion === 4) {
      setComercio();
      setMostrar5(false);
      return;
    }
    setComercio();
    setActividad();
    setActividadxCome();
    setInmuebleCome();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    renderizar();
  };

  const renderizar = () => {
    seleccionarComercios();
  };

  const consultarComercio = (id, index, permiso) => (event) => {
    event.preventDefault();
    if (permiso === "1") {
      setDeshabilitado(true);
      SelectComercio(id, index);
      setOperacion(4);
    } else {
      setToast({
        mostrar: true,
        titulo: "Notificación",
        mensaje: "No posee permiso para consultar un Contribuyente de actividades Economicas",
      });
    }
  };

  const editarComercio = (id, index, permiso) => (event) => {
    event.preventDefault();
    if (permiso === "1") {
      setOperacion(2);
      setDeshabilitado(false);
      SelectComercio(id, index);
    } else {
      setToast({
        mostrar: true,
        titulo: "Notificación",
        mensaje: "No posee permiso para editar un Contribuyente de actividades Economicas",
      });
    }
  };

  const eliminarComercio = (id, index, permiso) => (event) => {
    event.preventDefault();
    if (permiso === "1") {
      setOperacion(3);
      setDeshabilitado(true);
      SelectComercio(id, index);
    } else {
      setToast({
        mostrar: true,
        titulo: "Notificación",
        mensaje: "No posee permiso para eliminar un Contribuyente de actividades Economicas",
      });
    }
  };

  const buscarRegistrosGraficas = () => {
    console.log("Datos para gráfica:", conteoTipos);
  };

  useEffect(() => {
    const init = async () => {
      let obj = JSON.parse(localStorage.getItem("post"));
      setPermisoDecla(JSON.parse(localStorage.getItem("permisos")).accpermdecla);
      setPermisoExon(JSON.parse(localStorage.getItem("permisos")).accexoncomercio);
      setFechaSistema(obj.fechasistema);
      setIdUsuario(obj.idusuario);
      setEspiritu(obj.espiritu);
      
      // Cargar datos iniciales en paralelo
      await Promise.all([
        seleccionarComercios(),
        seleccionarConfiguracion(),
        seleccionarStatus(),
        seleccionarTiposContribuyente()
      ]);
      
      buscarRegistrosGraficas();
    };
    
    init();
  }, []);

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  // Preparar datos para la gráfica por tipo de contribuyente
  const getChartData = () => {
    if (Object.keys(conteoTipos).length > 0) {
      const labels = Object.keys(conteoTipos);
      const values = Object.values(conteoTipos);
      return {
        labels: labels,
        values: values
      };
    }

    return {
      labels: ["PERMANENTE", "TRANSEUNTE", "EVENTUAL O AMBULANTE", "IRREGULAR", "NO DEFINIDO"],
      values: [
        records.filter(r => r.tipocontribuyente && r.tipocontribuyente.trim() === "PERMANENTE").length,
        records.filter(r => r.tipocontribuyente && r.tipocontribuyente.trim() === "TRANSEUNTE").length,
        records.filter(r => r.tipocontribuyente && r.tipocontribuyente.trim() === "EVENTUAL O AMBULANTE").length,
        records.filter(r => r.tipocontribuyente && r.tipocontribuyente.trim() === "IRREGULAR").length,
        records.filter(r => !r.tipocontribuyente || r.tipocontribuyente === "").length,
      ],
    };
  };

  const chartDataFromTypes = getChartData();
  const chartLabels = chartDataFromTypes.labels;
  const chartValues = chartDataFromTypes.values;

  const generateColors = (count) => {
    const colors = ["#E74C3C", "#2ECC71", "#3498DB", "#F39C12", "#9B59B6", "#1ABC9C", "#E67E22", "#27AE60"];
    return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
  };
  
  const backgroundColors = generateColors(chartLabels.length);

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Distribución por Tipo de Contribuyente",
        data: chartValues,
        backgroundColor: backgroundColors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,0.8)",
        padding: 10,
        cornerRadius: 4,
      },
    },
  };

  return (
    <div style={styles.parent}>
      <div style={styles.div1}>
        <CardsModule
          title1={'Total Comercios'}
          title2={'Activos'}
          title3={'Inactivos'}
          total={records.length}
          activos={activeCount}
          inactivos={inactiveCount}
        />
      </div>

      <div style={styles.div2}>
        <div className="col-12 m-0 p-2 border rounded">
          <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
            <h3 className="fw-bold m-0">
              Gestión de Contribuyentes Actividades Económicas
            </h3>
            <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
              Salir <i className="fas fa-times ms-2"></i>
            </a>
          </header>
          <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
            <div className="col-6 col-lg-4 m-0 p-0">
              <SearchInput
                onChange={handleSearch}
                placeholder="Buscar"
              />
            </div>
            <div className="col-auto m-0 p-0">
              <PrimaryButton 
                icon='fa-plus m-0'
                onClick={agregarComercio(permiso.toString().substring(1, 2))}
                disabled={permiso.toString().substring(1, 2) !== "1"}
              />
            </div>
          </div>
          <div className="col-12 m-0 p-0">
            <TblContainer>
              <TblHead />
              <tbody>
                {recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idcomercio} style={{ padding: "0" }}>
                    <td className="align-baseline text-center">{item.idcomercio}</td>
                    <td className="align-baseline text-center">{item.ritm}</td>
                    <td className="align-baseline text-center">{item.rif}</td>
                    <td className="align-baseline text-center">{item.nombre}</td>
                    <td className="align-baseline text-center">{item.direccion}</td>
                    <td className="align-baseline text-center">{item.reprelegal}</td>
                    <td className="align-baseline text-center" style={{ width: '150px' }}>
                      <button
                        onClick={consultarComercio(item.idcomercio, item, permiso.toString().substring(0, 1))}
                        title="Consultar Contribuyente"
                        className={permiso.toString().substring(0, 1) === "1" ? "btn btn-sm btn-info rounded-pill" : "btn btn-sm btn-secondary rounded-pill"}
                      >
                        <i className="fas fa-eye"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={editarComercio(item.idcomercio, item, permiso.toString().substring(2, 3))}
                        title="Editar Con"
                        className={permiso.toString().substring(2, 3) === "1" ? "btn btn-sm btn-warning rounded-pill" : "btn btn-sm btn-secondary rounded-pill"}
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={eliminarComercio(item.idcomercio, item, permiso.toString().substring(3, 4))}
                        className={permiso.toString().substring(3, 4) === "1" ? "btn btn-sm btn-danger rounded-pill" : "btn btn-sm btn-secondary rounded-pill"}
                      >
                        <i className="fa fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </TblContainer>
            <TblPagination />
          </div>
        </div>
      </div>

      {/* Contenedor ajustado para el gráfico */}
      <div style={styles.div3}>
        <Card
          sx={{
            borderRadius: 4,
            boxShadow: 3,
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CardContent
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              align="center"
              mb={1}
              color="text.secondary"
              style={{ textTransform: "uppercase" }}
            >
              Distribución por Tipo de Contribuyente
            </Typography>

            <Box
              sx={{
                flex: 1,
                position: "relative",
                width: "100%",
                minHeight: "250px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Pie data={chartData} options={chartOptions} />
            </Box>

            <Box sx={{ flexGrow: 0, overflowY: "auto", maxHeight: "40%", mt: 1 }}>
              <List dense sx={{ py: 0 }}>
                {chartLabels.map((label, index) => (
                  <React.Fragment key={label}>
                    <ListItem sx={{ px: 1, py: 0.5 }} secondaryAction={
                      <Typography variant="body2" fontWeight="bold" color="text.primary">
                        {chartValues[index]}
                      </Typography>
                    }>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          backgroundColor: backgroundColors[index],
                          mr: 2,
                          flexShrink: 0,
                        }}
                      />
                      <ListItemText
                        style={{ textTransform: "uppercase" }}
                        primaryTypographyProps={{
                          variant: "caption",
                          noWrap: true,
                          sx: { fontSize: "11px" },
                        }}
                        primary={label}
                      />
                    </ListItem>
                    {index < chartLabels.length - 1 && <Divider component="li" />}
                  </React.Fragment>
                ))}
              </List>
            </Box>
          </CardContent>
        </Card>
      </div>

      <ActualizarComercio
        show={mostrar5}
        factorCambio={factorCambio?.valor}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuComercio}
        comercio={comercio}
        statuscome={statusCome}
        usuarioweb={usuariow}
        actividadcome={actividad}
        representante={persona}
        inmueble={inmuebleCome}
        tabdeuda={deuda}
        tabpago={historico}
        tabpagow={pagow}
        tabmulta={multas}
        tabactixcomer={actividadxCome}
        tabreten={retencion}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome.declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        permisodecla={permisoDecla}
        permisoexon={permisoExon}
        factpago={facturasPagadas}
        factpagoetax={facturasPagadasEtax}
        factotropagoetax={facturasOtrosPgosEtax}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
}

const styles = {
  parent: {
    display: "grid",
    gridTemplateColumns: "1fr 25%",
    gridTemplateRows: "auto 1fr",
    gridColumnGap: "20px",
    gridRowGap: "20px",
    height: "100vh",
    padding: "20px",
    backgroundColor: "#f5f5f5",
  },
  div1: {
    gridArea: "1 / 1 / 2 / 2",
  },
  div2: {
    gridArea: "2 / 1 / 3 / 2",
    overflow: "auto",
  },
  div3: {
    gridArea: "1 / 2 / 3 / 3",
    height: "82vh",
  },
};

export default TablaComercio;